export const menuData = [
  {
    ruta: "/dashboard",
    titulo: "Dashboard",
    icono: "home-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/proyectos",
    titulo: "Proyectos",
    icono: "list-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/tareas",
    titulo: "Tareas",
    icono: "file-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/catalogos",
    titulo: "Catálogos",
    icono: "book-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/roles",
    titulo: "Roles",
    icono: "lock-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/gestores",
    titulo: "Gestores",
    icono: "users-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/usuarios",
    titulo: "Usuarios",
    icono: "user-icon",
    color: "text-gray-600 dark:text-gray-400"
  },
  {
    ruta: "/buscador",
    titulo: "Buscador Público",
    icono: "search-icon",
    color: "text-gray-600 dark:text-gray-400"
  }
];
